import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type SupportedLocale } from '../config/localeConfig';

export type LocalePublishState = Partial<
  Record<
    SupportedLocale,
    {
      isPublished?: boolean;
      isIndexable?: boolean;
    }
  >
>;

export function stripLocalePrefix(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (!segments.length) return '/';

  const first = segments[0];
  if (SUPPORTED_LOCALES.includes(first as SupportedLocale)) {
    const rest = segments.slice(1).join('/');
    return rest ? `/${rest}` : '/';
  }

  return pathname || '/';
}

export function buildLocalizedUrl(siteUrl: string, locale: SupportedLocale, pathnameWithoutLocale: string) {
  const path = pathnameWithoutLocale === '/' ? '' : pathnameWithoutLocale;
  return `${siteUrl}/${locale}${path}`;
}

export function buildHreflangLinks(args: {
  siteUrl: string;
  pathname: string;
  localePublishState?: LocalePublishState;
}) {
  const { siteUrl, pathname, localePublishState } = args;
  const pathnameWithoutLocale = stripLocalePrefix(pathname);

  const links = SUPPORTED_LOCALES.flatMap((locale) => {
    const state = localePublishState?.[locale];

    if (localePublishState) {
      if (!state?.isPublished || !state?.isIndexable) return [];
    }

    return [
      {
        hreflang: locale,
        href: buildLocalizedUrl(siteUrl, locale, pathnameWithoutLocale),
      },
    ];
  });

  links.push({
    hreflang: 'x-default',
    href: buildLocalizedUrl(siteUrl, DEFAULT_LOCALE, pathnameWithoutLocale),
  });

  return links;
}
